
import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { CouponService } from "app/services";
import { PagedCouponsList } from "app/types/service-types/CouponTypes";

interface PromotionalCouponsState {
  loading: boolean;
  page: PagedCouponsList | null;
}

const initialState: PromotionalCouponsState = {
  loading: false,
  page: null,
};

const promotionalCouponsSlice = createSlice({
  name: "coupons/promotional",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setPromotionalCoupons(state, action: PayloadAction<PagedCouponsList>) {
      state.page = action.payload;
    },
  },
});

export const { setLoading, setPromotionalCoupons } =
  promotionalCouponsSlice.actions;

export const fetchPromotionalCoupons =
  (params?: { page?: number; size?: number;  }) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await CouponService.getCoupons({
        page: params?.page,
        size: params?.size,
        
      });

      dispatch(setPromotionalCoupons(response));
    } finally {
      dispatch(setLoading(false));
    }
  };


export default promotionalCouponsSlice.reducer;
